
export const state = {
  /** @type {Record<'stats' | 'errors', data.structures.RtbApiReturnValue>} */
  affiliatesStats: [],
  affiliatesErrors: [],
  status: {}
};